import { gallery } from 'constants.js'

const aspectRatio = gallery.THUMB_WIDTH / gallery.THUMB_HEIGHT

export const THUMB_WIDTH = 100
export const THUMB_HEIGHT = THUMB_WIDTH / aspectRatio
export const THUMB_SPACING = 25
export const SHELF_HEIGHT = 20
export const INDICATOR_SIZE = 4
export const LEFT_MARGIN = 20
